import pick from 'lodash/pick';

import config from '@config';

import createDataSource from './createDataSource';

const BASE_PATHNAME = 'translations';

export default () => {
  const dataSource = createDataSource(`${config.api.url}`);

  const get = () => dataSource.get(`${BASE_PATHNAME}/supported-languages`);

  const translateByFormValue = (values) => dataSource.post(BASE_PATHNAME, { json: { ...values } }).json();

  const translate = async ({ articleId, fromLanguage, toLanguage, fields }) => {
    const article = await dataSource.get(`articles/${articleId}/${fromLanguage}`).json();
    const pickedFields = pick(article, fields);

    return Promise.all(
      Object.keys(pickedFields).map((formKey) =>
        translateByFormValue({
          field: formKey,
          text: pickedFields[formKey],
          sourceLanguageCode: fromLanguage,
          targetLanguageCode: toLanguage,
        }),
      ),
    );
  };

  return {
    get,

    translate,
  };
};
